import { data } from '../../svg/LeftPanelOpen/data';
import { makeIcon } from '../makeIcon';

export const LeftPanelOpen = makeIcon(data, 'left_panel_open', 'LeftPanelOpen');

export default LeftPanelOpen;
